import React from 'react';
import BaseText from '../ui/typography/BaseText';
import { FONT_SIZE } from '../../constants/enum';
import TrustPilotSVG from '../../images/inline/trustpilotLogo.inline.svg';
import TrustPilot5SVG from '../../images/inline/trustpilot5.inline.svg';
import TrustPilot45SVG from '../../images/inline/trustpilot45.inline.svg';
function TrustpilotReviews({ reviews }) {
  return (
    <div className="flex global-max-width-wrapper mx-auto mt-10">
      <div className="mx-auto flex flex-col md:flex-row gap-16">
        <a href="https://www.trustpilot.com/review/air-corporate.com" target="_blank" className="flex flex-col gap-2 ">
          <BaseText fontSize={FONT_SIZE.PX_24} textAlign="text-center" fontWeight="text-bold" title="Excellent" />
          <TrustPilot45SVG />
          <TrustPilotSVG />
        </a>
        <div className="flex lg:flex-row flex-wrap gap-8 flex-col">
          {reviews?.map((review) => (
            <div className="w-64">
              <div className="mt-3 mb-2">
                <TrustPilot5SVG height="20" width="108" />
              </div>
              <BaseText
                fontWeight="text-bold"
                textColor="text-gray-400"
                fontSize={FONT_SIZE.PX_16}
                title={review?.title?.text}
              />
              <BaseText fontSize={FONT_SIZE.PX_13} title={review?.description.text} />
              <div className="flex mt-4 gap-1">
                <BaseText
                  textColor="text-gray-350"
                  fontWeight="text-bold"
                  fontSize={FONT_SIZE.PX_13}
                  title={review?.reviewer_name?.text}
                />
                <BaseText textColor="text-gray-400" fontSize={FONT_SIZE.PX_13} title={review?.review_date} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TrustpilotReviews;
